import moment from 'moment'

const initialState = {
  loading: false,
  loaded: false,
  stepCompleted: false,
  time: null,
  date: null,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return { ...initialState, date: moment().format('L'), time: new Date() }
    }
    case 'SET_TIME': {
      return {
        ...state,
        time: action.payload.time,
        date: action.payload.date,
        stepCompleted: true,
      }
    }

    default: {
      return state
    }
  }
}
